import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink as Link, useLocation } from "react-router-dom";

const Footer = () => {
  const [showTopUp, setShowTopUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const firstSectionHeight = document.getElementById("first-section")?.offsetHeight || 0;
      setShowTopUp(window.scrollY > firstSectionHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTopUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
  <footer className="leftrightSecSpace">
    <div className="footerIn">
      <div className="row">
        <div className="col-sm-3">
          <div className="fLogo">
            <img className="mb-2 logoSmall" src="./images/ptgc/logo.svg" alt="" />
            <p>(PTGC) is the first of it’s kind renounced, immutable, deflationary, cryptocurrency designed to generate passive income for holders without resorting to inflating the token supply. The Grays delivers the benefits of inflation without the actual inflation.</p>
          </div>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4">
          <ul>
            <li><Link to='/ptgc-staking'>Staking</Link></li>
            <li><Link to='/ptgc-dao'>Dao</Link></li>
            <li><Link to='/ptgc-onboarding'>Onboarding</Link></li>
            <li><Link to='/ptgc-statistics'>Statistics <span className="upper">New</span></Link></li>
            <li><Link to='https://the-grays-currency.printify.me/' target="_blank">The Grays Gear</Link></li>
          </ul>
        </div>
        <div className="col-sm-4">
          <ul>
            <li><Link target="_blank" to='https://dextools.io/app/en/pulse/pair-explorer/0xf5a89a6487d62df5308cdda89c566c5b5ef94c11?t=1709851942690'>Dextools</Link></li>
            <li><Link target="_blank" to='https://dexscreener.com/pulsechain/0xf5a89a6487d62df5308cdda89c566c5b5ef94c11'>DexScreener</Link></li>
            <li><Link target="_blank" to='https://coingecko.com/en/coins/the-grays-currency'>CoinGecko</Link></li>
          </ul>
        </div>
      </div>
      <div className="copy d-flex justify-content-between flex-wrap">
        <span className='mb-2'>The Grays Currency © {new Date().getFullYear()}. All rights reserved.</span>
        <span className="mb-2 social">
          <a target='_blank' href='https://youtube.com/@TheGraysCurrency'><i className="fa-brands fa-youtube"></i></a>
          <a target='_blank' href='https://web.telegram.org/k/#@thegrayscurrency'><i className="fa-brands fa-telegram"></i></a>
          <a target='_blank' href='https://x.com/PulseTGC'><i className="fa-brands fa-x-twitter"></i></a>
          <a target='_blank' href='https://1drv.ms/b/s!AvlLP8ZwBHi8gqodlPijKHnatedXMg?e=bncOEr'><i className="fa-solid fa-file"></i></a>
        </span>
      </div>
    </div>
  </footer>
  {showTopUp && (
        <button className='topup'
          onClick={handleTopUp}
          
        >
          <i className="fa-solid fa-chevron-up"></i>
        </button>
      )}

    </>
  );
};
export default Footer;